export default {
    breadcrumbs: {
        home: 'Домой',
        manage_account: 'Управление аккаунтом',
        preview: 'Просмотр аккаунта',
        user_profile: 'Профиль пользователя',
    },
    offer_tabs: {
        active: 'Активные ({number})',
        renewal: 'Для продления ({number})',
        expired: 'Истекшие ({number})',
    },
    tabs: {
        offers: 'Услуги',
    },
    modal: {
        complete_profile: 'Для предварительного просмотра аккаунта заполните имя и фамилию!',
        delete_profile: 'Вы уверены, что хотите удалить профиль?',
    },
    delete_profile_button: 'Удалить аккаунт',
}
